import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/soap.tsx
var Soap = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M13.1198 4.73316L5.82198 12.1797C5.54643 12.4624 5.27976 13.0194 5.22643 13.405L4.89754 16.1814C4.78198 17.184 5.52865 17.8695 6.55976 17.6981L9.42198 17.2268C9.82198 17.1583 10.382 16.8755 10.6575 16.5841L17.9553 9.13764C19.2175 7.85229 19.7864 6.38698 17.822 4.59605C15.8664 2.82226 14.382 3.4478 13.1198 4.73316Z",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeMiterlimit: "10",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M11.9023 5.97595C12.2846 8.34101 14.2757 10.1491 16.7468 10.389",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeMiterlimit: "10",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M4 20.5002H20",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeMiterlimit: "10",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M19.3846 20.4999H4.61538C4.27897 20.4999 4 20.2108 4 19.8622C4 19.5136 4.27897 19.2245 4.61538 19.2245H19.3846C19.721 19.2245 20 19.5136 20 19.8622C20 20.2108 19.721 20.4999 19.3846 20.4999Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M17.7597 4.75312C16.1679 3.10362 14.6089 3.0611 12.9761 4.75312L11.9833 5.78194C11.9012 5.86697 11.8684 6.00301 11.9012 6.12205C12.5248 8.37524 14.2643 10.1778 16.4387 10.824C16.4715 10.8325 16.5043 10.841 16.5371 10.841C16.6274 10.841 16.7095 10.807 16.7751 10.739L17.7597 9.71015C18.572 8.8769 18.9659 8.06915 18.9659 7.2529C18.9741 6.41114 18.5802 5.59488 17.7597 4.75312Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M14.962 11.5976C14.724 11.4786 14.4943 11.3595 14.2728 11.2235C14.0922 11.113 13.9199 10.9939 13.7476 10.8664C13.6081 10.7729 13.444 10.6368 13.2881 10.5008C13.2717 10.4923 13.2143 10.4413 13.1487 10.3732C12.8779 10.1352 12.5743 9.82906 12.3035 9.48896C12.2789 9.47195 12.2379 9.41243 12.1804 9.33591C12.0984 9.23388 11.9589 9.06383 11.8358 8.86827C11.7374 8.74073 11.6225 8.55367 11.5158 8.36661C11.3846 8.13704 11.2697 7.90747 11.1548 7.6694C11.1376 7.63111 11.1209 7.59302 11.1047 7.55514C10.9851 7.27532 10.6199 7.19488 10.4086 7.41386L5.71481 12.2778C5.60814 12.3884 5.50968 12.6009 5.48506 12.7455L5.04199 16.002C4.95994 16.5801 5.11583 17.1243 5.46045 17.4899C5.75583 17.7875 6.16609 17.9491 6.60917 17.9491C6.70763 17.9491 6.80609 17.9406 6.90455 17.9236L10.0553 17.4644C10.203 17.4389 10.4081 17.3369 10.5066 17.2263L15.2235 12.3384C15.429 12.1255 15.3492 11.7687 15.0783 11.6494C15.0401 11.6325 15.0014 11.6153 14.962 11.5976Z",
			fill: "currentColor"
		})
	] })
});
//#endregion
export { Soap };
